<template>
  <v-container grid-list-lg fluid>
    <SearchBar v-model="search" />

    <v-card outlined class="rounded-xl mt-5">
      <ListTitle title="Categories" @new="openCreateCategory" />

      <v-data-table
        class="table-header"
        :headers="headers"
        :items="categories"
        :loading="loading"
        :options.sync="options"
        :server-items-length="count"
        :footer-props="footerProps"
        item-key="id"
      >
        <!-- Row -->
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.productCount }}</td>

            <td class="text-xs-left">
              <v-tooltip top max-width="200">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{
                      props.item.MasterCategory &&
                      props.item.MasterCategory.name
                        ? props.item.MasterCategory.name
                        : "N/A"
                    }}
                  </span>
                </template>

                <span class="pa-3">
                  {{
                    props.item.MasterCategory &&
                    props.item.MasterCategory.description
                      ? props.item.MasterCategory.description
                      : "N/A"
                  }}
                </span>
              </v-tooltip>
            </td>

            <td class="justify-end layout px-0">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list class="menu-button">
                  <v-list-item @click="openEditCategory(props.item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="deleteCategory(props.item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog v-model="createDialog" max-width="550">
        <create
          :isModal="true"
          @close="closeCreateCategory"
          :searchText="search"
        />
      </v-dialog>

      <v-dialog v-if="editModel" v-model="editDialog" max-width="550">
        <edit
          :isModal="true"
          :id="editModel.id"
          @close="closeEdit"
          :searchText="search"
        />
      </v-dialog>
    </v-card>
  </v-container>
</template>

<script>
import categoryService from "../service";

const Create = () => import("./Create");
const Edit = () => import("./Edit");

export default {
  name: "category-list",
  components: { Create, Edit },

  data() {
    return {
      createDialog: false,
      editDialog: false,
      editModel: null,

      // ✅ No $t()
      headers: [
        { text: "Name", value: "name", sortable: false },
        { text: "Product Count", value: "productCount", sortable: false },
        { text: "Master Category", value: "MasterCategory", sortable: false },
        { text: "", value: "action", sortable: false },
      ],

      search: null,
      categories: [],
      count: 0,
      loading: false,

      // ✅ Vuetify 2: options replaces pagination
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["name"],
        sortDesc: [false],
      },

      // ✅ Vuetify 2: footer props replaces rows-per-page-items
      footerProps: {
        itemsPerPageOptions: [10, 25, 50, 100],
      },
    };
  },

  watch: {
    search(val) {
      const v = val || "";
      if (v.length > 3 || v.length === 0) this.getList();
    },

    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },

  mounted() {
    this.getList();
  },

  methods: {
    openCreateCategory() {
      this.createDialog = true;
    },
    closeCreateCategory() {
      this.createDialog = false;
    },

    openEditCategory(category) {
      this.editModel = category;
      this.editDialog = true;
    },
    closeEdit() {
      this.editDialog = false;
      this.editModel = null;
    },

    getList() {
      this.loading = true;

      const page = this.options.page || 1;
      const itemsPerPage = this.options.itemsPerPage || 10;

      const sortBy = (this.options.sortBy && this.options.sortBy[0]) || "name";
      const sortDesc =
        (this.options.sortDesc && this.options.sortDesc[0]) || false;

      const offset = itemsPerPage * page - itemsPerPage;

      return categoryService
        .getAll({
          limit: itemsPerPage,
          offset,
          search: this.search,
          orderBy: [sortBy, sortDesc],
          includeStock: true,
          includeProducts: true,
        })
        .then((response) => {
          this.categories = response.data;
          this.count = response.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    deleteCategory(category) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.$Progress.start();
          return categoryService
            .delete(category.id)
            .then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "Category has been deleted.", "success");
                this.$Progress.finish();
                this.getList();
              }
            })
            .catch((error) => {
              this.$swal
                .mixin({ toast: true, position: "top-end", timer: 2000 })
                .fire({
                  type: "error",
                  title:
                    error.data && error.data.message
                      ? error.data.message
                      : "Error",
                });
              this.$Progress.fail();
            });
        }
      });
    },
  },
};
</script>